import React from 'react';

import { Box } from '@mui/material';
import { NoAvailableMessage } from 'app/shared/components/common/NoAvailableMessage';
import ProgressBar from 'app/shared/components/common/ProgressBar';
import PropTypes from 'prop-types';

import { LoanFeesTestIds } from '../../../../LoanFees.testIds';

import CicFeeReasonEditItem from './CicFeeReasonEditItem';
import { containerStyles } from './ManageCICModal.styles';

const ManageCICModal = ({
  cicReasons,
  formContext,
  openCICModal,
  isLoading = false,
  isReadOnly = false,
  emptyMessage = 'No CIC reasons found for this fee',
}) => {
  return (
    <>
      {isLoading && <ProgressBar />}
      <Box data-testid={LoanFeesTestIds.MANAGE_CIC_MODAL_CONTENT} sx={containerStyles}>
        {cicReasons?.length ? (
          cicReasons.map(reason => (
            <CicFeeReasonEditItem
              formContext={formContext}
              isReadOnly={isReadOnly}
              key={reason.loanCicFeeChangeReasonId ?? reason.loanCicReasonId}
              openCICModal={openCICModal}
              reason={reason}
            />
          ))
        ) : (
          <NoAvailableMessage message={emptyMessage} />
        )}
      </Box>
    </>
  );
};

ManageCICModal.propTypes = {
  openCICModal: PropTypes.func.isRequired,
  formContext: PropTypes.object.isRequired,
  cicReasons: PropTypes.array,
  isLoading: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  emptyMessage: PropTypes.string,
};

export default ManageCICModal;
